module.exports = __webpack_public_path__ + "img/10.1babf6e7.png";